<template>
	<div class="collect-content">
		<div class="setting-top-box">
			<div class="fr">
				<!-- <div class="collect-btn-group">
					<button class="collect-btn active">文化咨讯</button>
					<button class="collect-btn">演出</button>
					<button class="collect-btn">培训</button>
					<button class="collect-btn">展览中心</button>
				</div> -->
				<div class="search-box">
					<input class="search-box__input" @keyup.enter="changeType(typeIndex,1,true)" v-model="searchTitle" placeholder="请输入搜索内容" />
					<img src="~@/assets/img/main/search.png" @click="changeType(typeIndex,1,true)" />
				</div>
				<!-- <div class="count-num">
					您共有<span>10</span>条消息
				</div> -->
			</div>
			<span class="setting-top-title">我的收藏</span>
		</div>
		<ss-article-list mode="2" :value="curData_" :finish="finish_" :busy="busy_" />
		<div class="right-navigation-box"  v-if="pageTotal_ > pageSize">
			<ssNavigation :total="pageTotal_" v-model="curPage" :size="pageSize" />
		</div>
	</div>
</template>

<script>
	import ssArticleList from '@/components/ss-article-list/ss-article-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		components: {
			ssArticleList
		},
		data() {
			return {
				curPage: 1,
				pageSize: 5,
			}
		}
	}
</script>

<style lang="scss">
	.collect-content{
		.setting-top-box{
			.search-box{
				margin-top: 4px;
				position: relative;
				display: inline-block;
				margin-right: 10px;
				.search-box__input{
					padding: 0 50px 0 13px;
					width:220px;
					height:30px;
					line-height:28px;
					background:rgba(255,255,255,1);
					border:1px solid rgba(222,222,222,1);
					border-radius:15px;
				}
				img{
					cursor: pointer;
					width: 18px;
					display: block;
					@include abs(6px, 14px);
				}
			}
			.collect-btn-group{
				display: inline-block;
				margin-right: 10px;
				.collect-btn{
					width: 90px;
					height: 35px;
					line-height: 33px;
					font-size: 16px;
					text-align: center;
					font-weight: 400;
					color: #A2A2A2;
					border: 1px solid #DDDDDD;
					background-color: #fff;
					margin-right: 17px;
					&.active{
						border-color: #1A6FFE;
						color: #1A6FFE;
					}
				}
			}
			.count-num{
				font-size: 20px;
				display: inline-block;
				font-weight: 400;
				color: #A2A2A2;
				line-height: 24px;
				span{
					font-size: 30px;
					color: #ff0000;
				}
			}
		}
		.article-list{
			padding: 30px;
			li{
				padding: 0;
				border: 1px solid #D3D3D3;
				.article-right-content{
					padding: 20px;
					height: 132px;
					.article-time{
						bottom: 15px;
					}
				}
				.article-img{
					width: 200px;
          & +  .article-right-content{
            width: 630px;
          }
				}
				.article-right-content{
					width: 830px;
				}
				& + li{
					margin-top: 20px;
				}
			}
		}
	}
</style>
